import { render, staticRenderFns } from "./pickPartnerProduct.vue?vue&type=template&id=0c08af24&scoped=true&"
import script from "./pickPartnerProduct.vue?vue&type=script&lang=js&"
export * from "./pickPartnerProduct.vue?vue&type=script&lang=js&"
import style0 from "./pickPartnerProduct.vue?vue&type=style&index=0&id=0c08af24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08af24",
  null
  
)

export default component.exports